import styled from 'styled-components';
import { Container, Image } from 'react-bootstrap';
import bgImage from '../../images/foot-container-bg.jpg';

export const FooterContainer = styled.div`
  background: #0c4724 url(${bgImage}) no-repeat top center;
  clear: both;
  @media print {
    display: none;
  }
`;

export const Clear = styled.div`
clear: both;
`;
export const FooterInnerContainer = styled.div`
  width: 1200px;
  margin: 0 auto;
  padding: 45px 0;
  font-family: 'Tungsten-Medium', arial, sans-serif;
  font-size: 18px;
  line-height: 24px;
  color: #2db13a;
  @media (max-width: 1199px) {
    width: 960px !important;
  }
  @media (max-width: 991px) {
    width: 728px !important;
  }
  @media (max-width: 767px) {
    width: 100% !important;
    margin: 0;
    padding: 35px 25px 15px;
    text-align: center;
  }
`;

export const FooterLeft = styled.div`
  float: left;
  width: 350px;
  text-align: left;
  @media (max-width: 1199px) {
    width: 270px;
    margin: 0 50px 0 0;
  }
  @media (max-width: 991px) {
    width: 220px;
    margin-right: 0;
  }
  @media (max-width: 767px) {
    float: none;
    width: 100%;
    margin: 0 0 25px 0;
    text-align: center;
  }
`;


export const AnchorStyle = styled.a`
  text-decoration: none;
  color: #d5c408;
  :hover {
    color: #fff;
  }
`;

export const FootMiddle = styled.div`
  float: left;
  width: 525px;
  text-align: left;
  @media (max-width: 1199px) {
    width: 230px;
    margin: 0 30px 0 0;
  }
  @media (max-width: 767px) {
    float: none !important;
    width: 100%;
    margin: 0 0 25px 0;
    text-align: center;
  }
`;
export const FootMiddleLeft = styled.div`
  float: left;
  width: 165px;
  text-align: left;
  @media (max-width: 1199px) {
    float: none;
  }
  @media (max-width: 767px) {
    float: none;
    width: 100%;
    text-align: center;
  }
`;

export const FootMiddleRight = styled.div`
  float: left;
  width: 360px;
  text-align: left;
  margin: 0 0 30px 0;
  @media (max-width: 991px) {
    float: left;
    width: 360px;
  }
  @media (max-width: 767px) {
    float: none;
    width: 100%;
    text-align: center;
  }
`;

export const FootRight = styled.div`
  float: right;
  width: 200px;
  text-align: left;
  @media (max-width: 1199px) {
    width: 240px;
  }
  @media (max-width: 767px) {
    float: none;
    width: 100%;
    text-align: center;
    margin: 0;
  }
`;

export const HeaderH2 = styled.h2`
  margin-bottom: 20px;
  font-family: 'Tungsten-Medium', arial, sans-serif;
  font-size: 26px;
  line-height: 26px;
  text-transform: uppercase;
  color: #fff;
`

export const ParaText = styled.p`
    margin-bottom: 0;
`;